import { observable, action } from 'mobx'
import { message } from 'hljd'
import { IMG_SUCCESS, IMG_WARNING, IMG_ERROR } from '@constant'
import Api from '@api/certification'
import { getMerchantInfo } from '@util'
import trim from 'lodash/trim'

export default class {
  constructor(certificationStore) {
    this.certificationStore = certificationStore
  }
  statusList = [
    {
      type: 1,
      text: '审核通过，可在用户端商家主页查看',
      color: '#2FC286',
      icon: IMG_SUCCESS
    },
    {
      type: 0,
      text: '审核中，审核通过后可在用户端商家主页查看',
      color: '#FF8C30',
      icon: IMG_WARNING
    },
    {
      type: 2,
      text: '审核不通过，请核实认证信息',
      color: '#FF5C5C',
      icon: IMG_ERROR
    }
  ]

  @observable status = {}
  @observable id = ''
  @observable brandId = 0
  @observable type = 'viewer'
  @observable name = ''
  @observable desc = ''
  @observable certificationInfo = []
  @observable certificationBrand = []
  @observable nameList = []
  @observable isNew = false
  @observable isSubmit = false

  @action
  init = ({
    name,
    desc,
    information = [],
    certifyMaterial = [],
    status,
    reason,
    id,
    type,
    isNew
  }) => {
    this.id = id || 0
    this.name = name
    this.desc = desc
    this.certificationInfo = certifyMaterial
    this.certificationBrand = information
    this.status = this.statusList.find(item => status == item.type) || {}
    this.type = type || 'viewer'
    this.isNew = isNew
    if (status == 2 && reason) {
      this.status.text = reason
    }

    this.getBrandList()
  }

  @action
  searchName = value => {
    const name = trim(value)
    this.name = name
    this.getBrandList(this.name)
  }

  @action
  changeName = async id => {
    const brandName = this.nameList.find(el => el.id == id).name
    const param = {
      brandName,
      merchantId: getMerchantInfo().id
    }
    const { data } = await Api.getNameStatus(param)

    if (data && data.length) {
      return message.warning('你已经认证了该品牌，请重新选择')
    }

    this.brandId = id
    this.name = brandName
  }

  @action
  getBrandList = async name => {
    const { data = [], success } = await Api.getBrandList({ name })
    if (success) {
      this.nameList = [{ id: 0, name }, ...data]
    }
  }

  @action
  getViewName = (name = '') => {
    let byteNum = 0
    const nameReplace = name.split('').reduce((acc, cur) => {
      byteNum = byteNum += this.isChinese(cur) ? 2 : 1
      return byteNum <= 20 ? acc + cur : acc
    }, '')

    return byteNum > 20 ? `${nameReplace}...` : nameReplace
  }

  isChinese = temp => /^[\u4e00-\u9fa5]{0,}$/.test(temp)

  @action
  changeDescription = value => {
    this.desc = value
  }

  @action
  changeCertificationInfo = (file, link, info) => {
    if (this.certificationInfo.length < 5) {
      this.certificationInfo = [
        ...this.certificationInfo,
        this.getPictureData(link, info)
      ]
    }
  }

  @action
  changeCertificationBrand = (file, link, info) => {
    if (this.certificationBrand.length < 10) {
      this.certificationBrand = [
        ...this.certificationBrand,
        this.getPictureData(link, info)
      ]
    }
  }

  @action
  getPictureData = (link, { width, height }) => ({
    coverPath: link,
    width,
    height
  })

  @action
  checkImageSize = (up, err, errTip) => {
    if (err.code === plupload.FILE_SIZE_ERROR && !this.isShownWarningSize) {
      message.warning('大小超过了10M')
    }
  }

  @action
  checkFileSize = (up, err, errTip) => {
    if (err.code === plupload.FILE_SIZE_ERROR && !this.isShownWarningSize) {
      message.warning('大小超过了50M')
    }
  }

  @action
  discard = () => {
    if (this.isNew) {
      this.certificationStore.deleteFirst()
      return
    }
    this.type = 'viewer'
    this.certificationStore.certificationList = []
    this.certificationStore.init()
  }

  @action
  deleteCertificationInfo = index => {
    this.certificationInfo.splice(index, 1)
    message.success('删除成功')
  }

  @action
  deleteCertificationBrand = index => {
    this.certificationBrand.splice(index, 1)
    message.success('删除成功')
  }

  @action
  submit = async () => {
    if (this.isSubmit) {
      return
    }
    this.isSubmit = true

    const param = {
      brandId: this.brandId,
      brandName: this.name,
      desc: this.desc,
      certifyMaterial: this.certificationInfo || [],
      information: this.certificationBrand || [],
      merchantId: getMerchantInfo().id
    }

    if (!this.isNew) {
      param.id = this.id
    }
    if (this.checkParamUsefull(param)) {
      const ApiInterface = this.isNew
        ? Api.addCertification
        : Api.editCertification
      const { success } = await ApiInterface(param)

      if (success) {
        this.type = 'viewer'
        this.isSubmit = false
        this.certificationStore.init()

        return message.success('提交成功')
      }
    }
    this.isSubmit = false
  }

  @action
  checkParamUsefull = ({ brandName, desc, certifyMaterial }) => {
    if (!brandName || !brandName.length) {
      message.warning('请输入名称')
      return false
    }
    if (!desc || !desc.length) {
      message.warning('请输入认证说明')
      return false
    }
    if (!certifyMaterial.length) {
      message.warning('请上传证明材料')
      return false
    }
    return true
  }

  @action
  deleteCertification = async id => {
    const { success } = await Api.deleteCertification({ id })
    if (success) {
      message.success('删除成功')
      this.certificationStore.init()
    }
  }

  @action
  previewCertification = () => {
    this.type = 'editor'
  }
}
